import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-articles-and-news-lobby-item',
  templateUrl: './articles-and-news-lobby-item.component.html',
  styleUrls: ['./articles-and-news-lobby-item.component.scss', './articles-and-news-lobby-item.component.en.scss'],
})
export class ArticlesAndNewsLobbyItemComponent {
    @Input({ required: true }) article!: any;
    @Input({ required: true }) articlesContentTypes!: any;
    @Input() isLoadingItem: boolean = false;

    getArticleTypeIcon(type: any) {
        let elem = this.articlesContentTypes.find((c: any) => c.id == type.key);
        return elem ? elem.iconUrl : null;
    }
}
